module.exports = __webpack_public_path__ + "static/waterback-4ee61461d2d5087464aad7f09838e0a9.jpg";